mutation AnalyzeTorahColumn($barMitzvah: String!, $image: Upload!) {
  analyzeTorahColumn(barMitzvah: $barMitzvah, image: $image) {
    ok
    errors
    torahColumnOverlay {
      id
      name
      firstSefariaId
      lastSefariaId
      skipPrefixWords
      cutTrailingWords
      analysisJson
      processingSuccess
      processingMessage
    }
  }
}
